import * as Sentry from '@sentry/nextjs'
import getEnv from './src/utils/getEnv'
import { beforeSendToSentry } from './src/utils/Sentry'


const SENTRY_DSN = getEnv['layanWebSentryDSN']
const ENVIRONMENT = getEnv['environment']

// init Sentry for monitoring and reporting

if (SENTRY_DSN && ENVIRONMENT !== 'local') {
  console.log('init sentry client')
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    normalizeDepth: 10,
    sampleRate: 0.5,
    tracesSampleRate: 0.25,
    ignoreErrors: [
      /Failed to register a ServiceWorker/,
      /Failed to execute 'removeChild' on 'Node'/,
      /Failed to execute 'insertBefore' on 'Node'/,
      /reCAPTCHA Timeout/,
    ],
    denyUrls: [
      /^chrome-extension:\/\//,
      /^moz-extension:\/\//,
      /^safari-extension:\/\//,
    ],
    beforeSend: (event, hint) => beforeSendToSentry(event, hint)
  })
}